export default "__VITE_ASSET__C_eRc$XC__"